import Login from 'pages/auth/login/Login';
import { routeConstant } from './RouteConstant';
import Forgot from 'pages/auth/forgot/Forgot';
import Otp from 'pages/auth/otp/Otp';
import ResetPassword from 'pages/auth/reset_password/ResetPassword';
import Dashboard from 'pages/general/admin/dashboard/Dashboard';
import AllTask from 'pages/general/user/all_task/AllTask';
import ManageUser from 'pages/general/admin/manage_user/ManageUser';
import ManageTask from 'pages/general/admin/manage_task/ManageTask';
import PurchaseOrder from 'pages/general/admin/purchase_order/PurchaseOrder';
import RoughListing from 'pages/general/admin/rough_listing/RoughListing';
import AddRoughListing from 'pages/general/admin/rough_listing/AddRoughListing';
import ViewRoughListing from 'pages/general/admin/rough_listing/ViewRoughListing';
import ManageProduct from 'pages/general/admin/manage_product/ManageProduct';
import ManageSubCategory from 'pages/general/admin/manage_sub_category/ManageSubCategory';
import ManageCategory from 'pages/general/admin/manage_category/ManageCategory';
import AddPurchaseOrder from 'pages/general/admin/purchase_order/AddPurchaseOrder';
import ViewPurchaseOrder from 'pages/general/admin/purchase_order/ViewPurchaseOrder';
import Inventory from 'pages/general/admin/inventory/Inventory';
import UpdateInventory from 'pages/general/admin/inventory/UpdateInventory';
import DetailInventory from 'pages/general/admin/inventory/DetailInventory';
import WOPT from 'pages/general/user/all_task/inprogress_column/Wopt';
import SaleOrderModal from 'pages/general/admin/sale_order/AddSaleOrder';
import SaleOrder from 'pages/general/admin/sale_order/SaleOrder';
import ViewSaleOrder from 'pages/general/admin/sale_order/ViewSaleOrder';
import InternalTransfer from 'pages/general/admin/internal_transfer/InternalTransfer';
import AddInternalTransfer from 'pages/general/admin/internal_transfer/AddInternalTransfer';
import ViewInternalTransfer from 'pages/general/admin/internal_transfer/ViewInternalTransfer';
import ReturnOrder from 'pages/general/admin/return_order/ReturnOrder';
import AddReturnOrder from 'pages/general/admin/return_order/AddReturnOrder';
import ViewReturnOrder from 'pages/general/admin/return_order/ViewReturnOrder';
import MatchProducts from 'pages/general/admin/match_products/MatchProducts';
import QRCodeManagement from 'pages/general/admin/qr_code/QRCodeManagement';



const commonRoute = [];

const publicRoute = [
    ...commonRoute,
    {
        path: routeConstant.login.path,
        title: routeConstant.login.title,
        Component: Login
    },
    {
        path: routeConstant.forgot.path,
        title: routeConstant.forgot.title,
        Component: Forgot
    },
    {
        path: routeConstant.otp.path,
        title: routeConstant.otp.title,
        Component: Otp
    },
    {
        path: routeConstant.resetPassword.path,
        title: routeConstant.resetPassword.title,
        Component: ResetPassword
    }
];
const userRoute = [
    ...commonRoute,
    {
        path: routeConstant.user.task.path,
        title: routeConstant.user.task.title,
        Component: AllTask
    },
    {
        path: routeConstant.user.wopt.path,
        title: routeConstant.user.wopt.title,
        Component: WOPT
    },

];
const adminRoute = [
    ...commonRoute,
    {
        path: routeConstant.admin.dashboard.path,
        title: routeConstant.admin.dashboard.title,
        Component: Dashboard
    },
    {
        path: routeConstant.admin.roughListing.list.path,
        title: routeConstant.admin.roughListing.list.title,
        Component: RoughListing
    },
    {
        path: routeConstant.admin.roughListing.addrl.path,
        title: routeConstant.admin.roughListing.addrl.title,
        Component: AddRoughListing
    },
    {
        path: routeConstant.admin.roughListing.viewrl.path,
        title: routeConstant.admin.roughListing.viewrl.title,
        Component: ViewRoughListing
    },
    {
        path: routeConstant.admin.po.list.path,
        title: routeConstant.admin.po.list.title,
        Component: PurchaseOrder
    },
    {
        path: routeConstant.admin.po.addpo.path,
        title: routeConstant.admin.po.addpo.title,
        Component: AddPurchaseOrder
    },
    {
        path: routeConstant.admin.po.viewpo.path,
        title: routeConstant.admin.po.viewpo.title,
        Component: ViewPurchaseOrder
    },
    {
        path: routeConstant.admin.so.list.path,
        title: routeConstant.admin.so.list.title,
        Component: SaleOrder
    },
    {
        path: routeConstant.admin.so.addso.path,
        title: routeConstant.admin.so.addso.title,
        Component: SaleOrderModal
    },
    {
        path: routeConstant.admin.so.viewso.path,
        title: routeConstant.admin.so.viewso.title,
        Component: ViewSaleOrder
    },
    {
        path: routeConstant.admin.inventory.list.path,
        title: routeConstant.admin.inventory.list.title,
        Component: Inventory
    },
    {
        path: routeConstant.admin.inventory.upinventory.path,
        title: routeConstant.admin.inventory.upinventory.title,
        Component: UpdateInventory
    },
    {
        path: routeConstant.admin.inventory.detailinventory.path,
        title: routeConstant.admin.inventory.detailinventory.title,
        Component: DetailInventory
    },
    {
        path: routeConstant.admin.manageUser.path,
        title: routeConstant.admin.manageUser.title,
        Component: ManageUser
    },
    {
        path: routeConstant.admin.manageTask.path,
        title: routeConstant.admin.manageTask.title,
        Component: ManageTask
    },
    {
        path: routeConstant.admin.manageProduct.path,
        title: routeConstant.admin.manageProduct.title,
        Component: ManageProduct
    },
    {
        path: routeConstant.admin.internalTransfer.list.path,
        title: routeConstant.admin.internalTransfer.list.title,
        Component: InternalTransfer
    },
    {
        path: routeConstant.admin.internalTransfer.addit.path,
        title: routeConstant.admin.internalTransfer.addit.title,
        Component: AddInternalTransfer
    },
    {
        path: routeConstant.admin.internalTransfer.viewit.path,
        title: routeConstant.admin.internalTransfer.viewit.title,
        Component: ViewInternalTransfer
    },
    {
        path: routeConstant.admin.returnOrder.list.path,
        title: routeConstant.admin.returnOrder.list.title,
        Component: ReturnOrder
    },
    {
        path: routeConstant.admin.returnOrder.addreturn.path,
        title: routeConstant.admin.returnOrder.addreturn.title,
        Component: AddReturnOrder
    },
    {
        path: routeConstant.admin.returnOrder.viewreturn.path,
        title: routeConstant.admin.returnOrder.viewreturn.title,
        Component: ViewReturnOrder
    },
    {
        path: routeConstant.admin.matchProducts.list.path,
        title: routeConstant.admin.matchProducts.list.title,
        Component: MatchProducts
    },
    {
        path: routeConstant.admin.qrCodes.list.path,
        title: routeConstant.admin.qrCodes.list.title,
        Component: QRCodeManagement
    }
];

export { publicRoute, adminRoute, userRoute };
